<template>
  <div class="layout-container">
    <!-- 顶部标题栏 -->
    <TopHeader />

    <div class="layout-body">
      <!-- 左侧导航菜单 -->
      <LeftMenuTree />

      <!-- 右侧内容区：子页面在这里渲染 -->
      <div class="main-content">
        <router-view :key="$route.fullPath"/>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetSurveyStatus } from '@/api/survey'
import TopHeader from '@/components/TopHeader.vue'
import LeftMenuTree from '@/components/LeftMenuTree.vue'

export default {
  name: 'LayoutMain',
  components: {
    TopHeader,
    LeftMenuTree
  },
  mounted() {
    this.checkSurveyRule()
  },
  watch: {
    // 路由发生变化，重新执行问卷校验
    $route() {
      this.checkSurveyRule()
    }
  },
  methods: {
    async checkSurveyRule() {
      try {
        const res = await apiGetSurveyStatus()
        if(res.code === 200) {
          // 更新vuex状态
          this.$store.commit("user/SET_SURVEY_STATUS", res.data)
          const {preTestFinished,courseFinished,postTestFinished} = res.data

          //① 已经完成后测问卷，禁止再次访问后测页面
          if (this.$route.path === '/survey/post-test' && postTestFinished) {
            this.$router.push('/home')
            return
          }
          //② 未完成前测：只能访问前测问卷
          if (!preTestFinished) {
            if(this.$route.path !== '/survey/pre-test'){
              this.$router.push('/survey/pre-test')
            }
            return
          }
          //③ 已完成前测，禁止重复进入前测问卷
          if (preTestFinished && this.$route.path === '/survey/pre-test') {
            this.$router.push('/home')
            return
          }
          //④ 课程未全部完成，禁止访问后测问卷
          if (!courseFinished && this.$route.path === '/survey/post-test') {
            this.$router.push('/home')
            return
          }
        }
      } catch (err) {
        console.error("获取问卷状态异常", err)
      }
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.layout-body {
  flex: 1;
  display: flex;
  overflow: hidden;
}
.main-content {
  flex: 1;
  padding: 20px;
  background: #f5f7fa;
  overflow-y: auto;
}
</style>